import httpBuildQuery from '../../../httpBuildQuery'
import { ApplicationState } from '../../ApplicationState'

export const TRACK_USER_EVENT = 'V2/TrackFunction/UseFeature'

export const trackUserEvent = (featureName: string) => ({
    type: TRACK_USER_EVENT,
    payload: ({ fetchSimple, getState }) => {
        const state: ApplicationState = getState()

        fetchSimple('/track-user-event', {
            method: 'POST',
            body: httpBuildQuery({
                featureName: featureName,
                organization: state.tidewaysContext.organization?.name,
                application: state.tidewaysContext.application?.name,
            }),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
        })
    },
})
